/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlCompleteOTPRequest
 */
export interface ControlCompleteOTPRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlCompleteOTPRequest
     */
    mfa_token: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCompleteOTPRequest
     */
    otp: string;
}

/**
 * Check if a given object implements the ControlCompleteOTPRequest interface.
 */
export function instanceOfControlCompleteOTPRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mfa_token" in value;
    isInstance = isInstance && "otp" in value;

    return isInstance;
}

export function ControlCompleteOTPRequestFromJSON(json: any): ControlCompleteOTPRequest {
    return ControlCompleteOTPRequestFromJSONTyped(json, false);
}

export function ControlCompleteOTPRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCompleteOTPRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mfa_token': json['mfa_token'],
        'otp': json['otp'],
    };
}

export function ControlCompleteOTPRequestToJSON(value?: ControlCompleteOTPRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mfa_token': value.mfa_token,
        'otp': value.otp,
    };
}

